import cx from 'classnames'

export interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  bgColor?: BgColor
  verticalPadding?: 'default' | 'first' | 'xs' | 'xxs' | 'none'
  noTopPadding?: boolean
  noBottomPadding?: boolean
  noVerticalPadding?: boolean
  noHorizontalPadding?: boolean
  noPadding?: boolean
  className?: string
  children: React.ReactNode
  overflowHidden?: boolean
  relative?: boolean
}

const Section = ({
  bgColor = 'gray',
  className,
  verticalPadding = 'default',
  noTopPadding,
  noBottomPadding,
  noVerticalPadding,
  noHorizontalPadding,
  noPadding,
  overflowHidden,
  relative,
  children,
  ...props
}: SectionProps): JSX.Element => (
  <section
    className={cx(
      '',
      bgColor === 'gray' && 'bg-grey',
      bgColor === 'white' && 'bg-white',
      bgColor === 'darkgray' && 'bg-neutral',
      bgColor === 'darkgray-2' && 'bg-neutral-on-dark-7',
      overflowHidden && 'overflow-hidden',
      relative && 'relative',
    )}
  >
    <div
      className={cx(
        'max-w-screen-2xl mx-auto horizontal-padding',

        verticalPadding === 'default' && 'py-20 md:py-30 lg:py-40',
        verticalPadding === 'first' &&
          'pt-16 pb-20 md:pt-20 md:pb-30 lg:pt-30 lg:pb-40',
        verticalPadding === 'xs' && 'py-16 md:py-20 lg:py-30',
        verticalPadding === 'xxs' && 'py-12 md:py-16 lg:py-24',
        verticalPadding === 'none' && '',

        noTopPadding && '!pt-0',
        noBottomPadding && '!pb-0',
        noVerticalPadding && '!py-0',
        noHorizontalPadding && '!px-0',
        noPadding && '!p-0',

        className,
      )}
      {...props}
    >
      {children}
    </div>
  </section>
)

export default Section
